@use '../../style/globals.scss' as *;

.blur {
    &.visible {
        // Needed for safari
        -webkit-backdrop-filter: blur(10px);
    }
}

.modalDrawer {
    position: absolute;
    outline: none;

    &:focus,
    &:focus-visible,
    &:-moz-focusring {
        outline: none;
    }

    z-index: 5;
    top: calc(100% + 100px);
    left: 0px;
    transition: top 300ms ease-out, transform 300ms ease-out;
    width: 100%;
    pointer-events: none;

    &.visible {
        top: 50%;
        transform: translateY(-50%);
    }
}

$space-for-menu-buttons: 200px; // To allow for main menu and chat buttons to be visible around modal
$space-for-close-button: 50px; // To stop close button getting cut off

.Modal {
    position: relative;
    width: 565px;
    max-width: 100%;
    height: 227px;
    max-height: calc(100vh - var(--sait, 0px) - var(--saib, 0px) - $space-for-close-button);
    // Fix for mobile safari
    max-height: calc(100dvh - var(--sait, 0px) - var(--saib, 0px) - $space-for-close-button);
    padding: 10px 2px;
    margin: 0 auto;
    background-size: 100% 100%;
    color: var(--token-accent-theme-1-text-text-default);
    text-align: center;
    pointer-events: all;

    .modalTitle {
        font-family: var(--font-primary);
        font-size: $font-size-h5;
    }

    &.noBackgroundImage {
        background-color: var(--token-accent-theme-1-interface-mono-interface-midground);
        border-radius: 10px;
    }

    &.leaveSpaceAboveAndBelow {
        max-height: calc(100vh - $space-for-menu-buttons - var(--sait, 0px) - var(--saib, 0px));
        // Fix for mobile safari
        max-height: calc(100dvh - $space-for-menu-buttons - var(--sait, 0px) - var(--saib, 0px));

        .contentContainer {
            max-height: calc(100vh - ($space-for-menu-buttons + 20px) - var(--sait, 0px) - var(--saib, 0px));
            // Fix for mobile safari
            max-height: calc(100dvh - ($space-for-menu-buttons + 20px) - var(--sait, 0px) - var(--saib, 0px));
        }
    }

    .closeButton {
        position: absolute;
        z-index: 1;

        &.round {
            top: -10px;
            right: -10px;
            width: 36px;
            height: 36px;
        }

        &.icon {
            top: 10px;
            right: 10px;
        }
    }

    .contentContainer {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        height: 100%;
        max-height: calc(100vh - var(--sait, 0px) - var(--saib, 0px) - $space-for-close-button);
        max-height: calc(100dvh - var(--sait, 0px) - var(--saib, 0px) - $space-for-close-button);
        padding: 20px;
    }

    &.canScroll {
        .contentContainer {
            @include scrollbar-styles;
            display: block;
            overflow: auto;
        }
    }
}
